(function(){
  var mock = '';//JST[ Object.keys(JST).get('firstObject') ]();

  Pegasus.EditorProxy = Em.ObjectController.extend({
    content: Em.Object.create({
      state: 'draft',
      name: 'Email Name',
      from_label: 'Joe Rider',
      from_address: 'joe@rider.from_address.com',
      reply_to: 'joe@rider.reply_to.com',
      message: mock,
      unsubscribe_message: 'Click here to {UNSUBSCRIBE_LINK}',
      company: "Company",
      street_address: "123 Main St.",
      locality: "SF",
      region: "CA",
      postal_code: "12345",
      subject: 'no interesante',
      serialize: function(){
        return this;
      }
    }),
    mergeFields: {
      EMAIL_ADDRESS: 'Email Address',
      FIRST_NAME: 'First Name',
      CUSTOM_FIELD_1: 'User Defined Field 1'
    },
    didLoadEditor: function(sender){
      //sender.send('changeEditorContext');
    }
  });
})();
